
export default class DateFilter {
  constructor () {
    this._filter = document.getElementById('date-filter-input')
    this.wrapper = document.getElementById('date-filter')
    this.filter = { date: undefined }
  }

  static get EVENT () {
    return {
      CHANGE: 'poin:dateFilter:change'
    }
  }

  async init () {
    const queryParams = new URLSearchParams(window.location.search)
    const date = queryParams.get('date')

    this._filter.addEventListener('change', async () => {
      await this.change()
    })

    if (date) {
      console.log(date)
      this.filter.date = date
      this._filter.value = date
    }
  }

  async change () {
    console.log(this._filter.value)
    this.filter.date = this._filter.value
    this._filter.dispatchEvent(new Event(DateFilter.EVENT.CHANGE, { bubbles: true }))
  }

  clean () {
    this.filter.date = undefined
    this._filter.value = undefined
    this._filter.dispatchEvent(new Event(DateFilter.EVENT.CHANGE, { bubbles: true }))
  }

  filterIsSet () {
    return Boolean(this.filter.date)
  }
}
